<template>
  <i :class="'eb-icon eb-icon-' + name" :style="styleObj"></i>
</template>

<script>
export default {
  name: "EbIcon",
  data() {
    return {};
  },
  props: {
    name: String,
    size: {
      type: [String, Number],
      default: 14
    },
    active: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    styleObj() {
      const styleObj = {};
      if (String(this.size).indexOf("px") === -1) {
        styleObj.fontSize = `${this.size}px`;
      } else {
        styleObj.fontSize = this.size;
      }

      return styleObj;
    }
  }
};
</script>
